import React from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeProvider, css } from 'styled-components'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import 'slick-carousel/slick/slick.css'

import '../fonts/stylesheet.css'
import './layout.css'

const Wrapper = styled.div`
  ${props =>
    props.noOverflowHidden !== true &&
    css`
      overflow: hidden;
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-family: 'PAYBACK_Light';
      font-weight: 300;
      color: #4b4b4d;

      strong {
        font-family: 'PAYBACK_Bold';
        font-weight: 700;
      }
    `}

  ${props =>
    props.theme.name === 'platinum' &&
    css`
      color: #535659;
    `}
`

const Layout = ({
  children,
  theme = {},
  styleGray,
  noOverflowHidden = false,
}) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'Beantragen Sie Ihre Kreditkarte bei American Express bequem online.',
            },
            {
              name: 'keywords',
              content:
                'Kreditkarten Vergleich, Kreditkartenvergleich, beste kreditkarte, vergleich kreditkarte, kreditkarten im vergleich',
            },
            {
              name: 'robots',
              content: 'noindex',
            },
          ]}>
          <html lang="de" />
        </Helmet>
        <ThemeProvider theme={theme}>
          <Wrapper noOverflowHidden={noOverflowHidden}>
            {children}
          </Wrapper>
        </ThemeProvider>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
